import React, { useState, useEffect } from "react";
import {
  PieChartOutlined,
  UserOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LogoutOutlined,
  CommentOutlined,
  BellOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Badge, Button, ConfigProvider, Dropdown, Layout } from "antd";
import { Link, Outlet } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/reduxHooks";
import {
  LOGOUT_USER,
  // User,
} from "../../store/slices/authSlice/authSlice";
import classes from "./style/PageMainRoute.module.css";

import theme from "antd/lib/theme";
import { NotificationsDrawer } from "../../components/Notifications/NotificationsDropDown/NotificationsDrawer";
import { SELECT_NOTIFICATIONS_COUNT } from "../../store/selectors/notificationsSelectors";
import { Logo } from "../../components/Logo/Logo";
import { IRouting } from "../../store/slices/routingSlice/routingSlice";
import { SidebarMenu } from "../../components/SidebarMenu/SidebarMenu";
import { useGetPermissionQuery } from "../../store/api/permission.api";
// import { ModalCreateApplication } from "../../components/ModalCreateApplication/ModalCreateApplication";
const { Header, Content, Footer, Sider } = Layout;
type MenuItem = Required<MenuProps>["items"][number];

// type TypeWssApplication = {
//   agent_bank_id: number;
//   agent_id: number;
//   bg_type_id: number;
//   finish_bg_at: string;
//   id: number;
//   inn: string;
//   is_tax_simple: boolean;
//   link: string;
//   organization_id: number;
//   start_bg_at: string;
//   total_sum: string;
//   status_id: number;
// };

// type TypeResWssAppStatus = {
//   data: {
//     application: TypeWssApplication;
//     status: StatusObj;
//   };
//   type: "app";
// };

// type TypeResWssAppBank = {
//   data: {
//     application: TypeWssApplication;
//     bank: IBank;
//   };
//   type: "app";
// };

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[]
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

// type TypeResWssMessages = {
//   id: number;
//   sender_user_id: number;
//   receiver_user_id: number;
//   application_id: number;
//   text: string;
//   read_at: string | null;
//   is_my: boolean;
//   created_at: string | null;
// };
// type TypeResWssUser = User;
// type TypeResWssChat = {
//   data: {
//     message: TypeResWssMessages;
//     user: TypeResWssUser;
//   };
//   type: "messages";
// };

export const PageMainRoute = (props: { routes: IRouting[] }) => {
  const { data: permissionData } = useGetPermissionQuery();
  const userEmail = permissionData?.data.user.email;
  const { routes } = props;
  const date = new Date();
  //const USER_ID = useAppSelector(ID_USER_AUTH);
  const countHistoryNotifications = useAppSelector(SELECT_NOTIFICATIONS_COUNT);
  const [activeMenu, setActiveMenu] = useState("");
  const [openNotification, setOpenNotification] = useState(false);
  const [countNotification, setCountNotification] = useState(0);
  const [collapsed, setCollapsed] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [currentMenu, setCurrentMenu] = useState("1");
  // const [openCreateApplication, setOpenCreateApplication] = useState(false);
  const dispatch = useAppDispatch();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  // установить количество уведомлений
  useEffect(() => {
    setCountNotification(countHistoryNotifications);
  }, [countHistoryNotifications, setCountNotification]);

  // задержка, чтобы сначала прогрузилась меню и сайдбар
  useEffect(() => {
    const delay = 30;

    const timer = setTimeout(() => {
      setShowContent(true);
    }, delay);

    return () => clearTimeout(timer);
  }, []);

  // подключение к сокету
  // useEffect(() => {
  //   const WSS_ECHO = new Echoi();
  //   let isConnected = true;
  //   let connectionAttempts = 0;

  //   const connectWss = () => {
  //     const WSS_SISTEM = WSS_ECHO._getWss();

  //     if (isConnected) {
  //       if (USER_ID) {
  //         WSS_SISTEM.private("user." + USER_ID)
  //           .listen("PrivateUserMessageEvent", (res: TypeResWssChat) => {
  //             const app_id = Number(window.location.pathname.split("/").pop());
  //             if (res?.data?.message) {
  //               dispatch(
  //                 ADD_APP_EVENT({
  //                   app_id: res.data.message.application_id,
  //                   isNewMessage: true,
  //                 })
  //               );
  //               dispatch(
  //                 UP_DATE_IS_NEW_MESSAGE({
  //                   id: +res.data.message.application_id,
  //                   isNewMessage: true,
  //                 })
  //               );

  //               if (+res.data.message.application_id === app_id) {
  //                 dispatch(REQUEST_CHAT_ADD_MESSAGE(res?.data?.message));
  //               } else {
  //                 dispatch(
  //                   UP_DATE_IS_READ({
  //                     id: +res.data.message.application_id,
  //                     read: true,
  //                   })
  //                 );
  //               }
  //             }
  //           })
  //           .listen("PrivateUserAppStatusEvent", (res: TypeResWssAppStatus) => {
  //             if (res.data.status) {
  //               dispatch(
  //                 ADD_APP_EVENT({
  //                   app_id: res.data.application.id,
  //                   application: { status: res.data.status },
  //                 })
  //               );
  //               dispatch(
  //                 UP_DATE_IS_READ({
  //                   id: res.data.application.id,
  //                   read: true,
  //                 })
  //               );
  //               dispatch(
  //                 UP_DATE_APPLICATION_STATUS({
  //                   id: res.data.application.id,
  //                   status: res.data.status,
  //                 })
  //               );
  //             }
  //           })
  //           .listen(
  //             "PrivateUserAppBankChangeEvent",
  //             (res: TypeResWssAppBank) => {
  //               if (res.data.bank) {
  //                 dispatch(
  //                   ADD_APP_EVENT({
  //                     app_id: res.data.application.id,
  //                     bank: { title: res.data.bank.title },
  //                   })
  //                 );
  //                 dispatch(
  //                   UP_DATE_IS_READ({
  //                     id: res.data.application.id,
  //                     read: true,
  //                   })
  //                 );
  //               }
  //             }
  //           )
  //           .error((err: { type: string }) => {
  //             if (err.type === "AuthError" && connectionAttempts === 0) {
  //               connectionAttempts++;
  //               connectWss();
  //             } else {
  //               // eslint-disable-next-line no-console
  //               console.error("Уведомления перестали работать.");
  //               isConnected = false;
  //               WSS_SISTEM.disconnect();
  //             }
  //           });
  //       }
  //     }
  //     return () => {
  //       isConnected = false;
  //       WSS_SISTEM.disconnect();
  //     };
  //   };

  //   connectWss();
  // }, [USER_ID, dispatch]);

  // const toogleOpenCreateApplication = (isOpen: boolean) => {
  //   setOpenCreateApplication(isOpen);
  // };

  const onClickMenu: MenuProps["onClick"] = (e) => {
    setActiveMenu("menu");
    setCurrentMenu(e.key);
  };

  const openComment = () => {
    setActiveMenu("comment");
  };

  const openBellOut = () => {
    setActiveMenu("bellOut");
    setOpenNotification(true);
  };

  const openUserPage = () => {
    setActiveMenu("user");
    setCurrentMenu("-1");
  };

  const closeNotificatrions = () => {
    setTimeout(() => setOpenNotification(false), 300);
  };

  const resetActiveMenu = () => {
    setActiveMenu("");
    setCurrentMenu("-1");
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#009B3A",
        },
        components: {
          Button: {
            colorPrimary: "#009B3A",
          },
          Layout: {
            siderBg: "#EEF8E9",
          },
          Menu: {
            itemBg: "#EEF8E9",
            itemSelectedBg: "#009B3A",
            itemSelectedColor: "#fff",
          },
          Table: {
            rowHoverBg: "#F3FFED",
          },
        },
      }}
    >
      <Layout style={{ minHeight: "100vh" }}>
        <Header className={classes.header}>
          <div className={classes.headerButtons}>
            <div className="">
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{
                  fontSize: "16px",
                  width: 80,
                  height: 64,
                }}
              />
            </div>

            <Logo />
          </div>
          <div className={classes.icons}>
            <div style={{ color: "#bfbfbf", fontSize: "13.5px" }}>
              {userEmail}
            </div>
            <CommentOutlined
              className={
                activeMenu === "comment" ? classes.activeIcon : classes.icon
              }
              onClick={openComment}
            />
            <div>
              <Badge style={{ top: -5 }} count={countNotification} size="small">
                <BellOutlined
                  className={
                    activeMenu === "bellOut" ? classes.activeIcon : classes.icon
                  }
                  onClick={openBellOut}
                />
              </Badge>
            </div>
            {openNotification && (
              <NotificationsDrawer
                active={openNotification}
                close={closeNotificatrions}
                resetActiveMenu={resetActiveMenu}
              />
            )}
            <Dropdown
              menu={{
                items: [
                  getItem(
                    <Link to={"/profile"} onClick={openUserPage}>
                      Профиль
                    </Link>,
                    "1",
                    <PieChartOutlined onClick={openUserPage} />
                  ),
                  getItem(
                    <a onClick={() => dispatch(LOGOUT_USER())}>Выход</a>,
                    "2",
                    <LogoutOutlined onClick={() => dispatch(LOGOUT_USER())} />
                  ),
                ],
              }}
              placement="bottom"
              arrow
            >
              <UserOutlined
                className={
                  activeMenu === "user" ? classes.activeIcon : classes.icon
                }
                onClick={(e) => e.preventDefault()}
              />
            </Dropdown>
          </div>
        </Header>
        <Layout>
          <Sider
            style={{
              overflow: "auto",
              height: "100vh",
              position: "fixed",
              left: 0,
              top: 64,
              bottom: 0,
              zIndex: 6,
              transition: "0.5s",
            }}
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            trigger={null}
          >
            <div className="demo-logo-vertical" />
            <SidebarMenu
              routes={routes}
              onClick={onClickMenu}
              selectedKeys={[currentMenu]}
            />
          </Sider>
          <Layout
            style={{ marginLeft: collapsed ? 80 : 200, transition: "0.5s" }}
          >
            {showContent && (
              <Content>
                <div
                  style={{
                    padding: 24,
                    height: "100%",
                    background: colorBgContainer,
                  }}
                >
                  <Outlet />
                </div>
              </Content>
            )}
            <Footer style={{ textAlign: "center" }}>
              ITOnline все права защищены ©{date?.getFullYear()}
            </Footer>
          </Layout>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};
